import { combineReducers } from 'redux';

import calendar from './calendar.reducer';
import calendarEventsSummary from './calendarEventsSummary.reducer';

const reducer = combineReducers({
  calendar,
  calendarEventsSummary,
});

export default reducer;
